import React from 'react';
import { FormattedMessage } from 'react-intl';

type TProps = {
  title: string;
};

const PatientsTitle: React.FC<TProps> = ({ title }) => (
  <div className="section-title">
    <FormattedMessage id={title} />
  </div>
);

export default PatientsTitle;
